module.exports = __webpack_public_path__ + "img/production1.4cb7b096.png";